import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import "firebase/firestore";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { Employee } from "../models/employee.model";

@Injectable({
  providedIn: "root",
})
export class EmployeeService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<Employee>;

  constructor(private db: AngularFirestore, private userStore: UserService) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getEmployees(shopId: string): AngularFirestoreCollection<Employee> {
    return this.db.collection(this.dbPath + `/${shopId}/employees`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .orderBy("updatedOn", "desc")
    );
  }

  getSellerEmployees(shopId: string): AngularFirestoreCollection<Employee> {
    return this.db.collection(this.dbPath + `/${shopId}/employees`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("isSeller", "==", true)
        .orderBy("updatedOn", "desc")
    );
  }

  getDelivererEmployees(shopId: string): AngularFirestoreCollection<Employee> {
    return this.db.collection(this.dbPath + `/${shopId}/employees`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("isDeliverer", "==", true)
        .orderBy("updatedOn", "desc")
    );
  }

  getCounSellorEmployees(shopId: string): AngularFirestoreCollection<Employee> {
    return this.db.collection(this.dbPath + `/${shopId}/employees`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("isCounSellor", "==", true)
        .orderBy("updatedOn", "desc")
    );
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/employees`)
      .doc(id)
      .valueChanges();
  }

  create(employee: Employee): any {
    employee.isActive = true;
    employee.isDeleted = false;
    employee.createdOn = new Date();
    employee.createdBy = this.userLogin.uid;
    employee.updatedOn = new Date();
    employee.updatedBy = this.userLogin.uid;
    employee.author = this.userLogin;
    employee.visibility = this.visibility;

    employee.isCounSellor = !employee.isCounSellor ? false : true;
    employee.isSeller = !employee.isSeller ? false : true;
    employee.isDeliverer = !employee.isDeliverer ? false : true;

    employee.shopId = employee.shopId ? employee.shopId : this.userLogin.shopId;

    this.collRef = this.db.collection(
      this.dbPath + `/${employee.shopId}/employees`
    );

    return this.collRef.add({ ...employee }).then((docRef) => {
      employee.id = docRef.id;
      return employee;
    });
  }

  update(employee: Employee): Promise<void> {
    console.log("update employee:", employee);

    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${employee.shopId}/employees`
    );
    return this.collRef.doc(employee.id).update({
      email: employee.email ? employee.email : "",
      mobile: employee.mobile ? employee.mobile : "",
      cardId: employee.cardId ? employee.cardId : "",

      fullName: employee.fullName ? employee.fullName : "",
      firstName: employee.firstName ? employee.firstName : "",
      lastName: employee.lastName ? employee.lastName : "",
      dob: employee.dob ? employee.dob : new Date(),
      dobYear: employee.dobYear ? employee.dobYear : 2000,
      dobMonth: employee.dobMonth ? employee.dobMonth : 1,
      dobDay: employee.dobDay ? employee.dobDay : 1,
      gender: employee.gender,
      address: employee.address,
      tax: employee.tax ? employee.tax : "",
      description: employee.description,
      coverUrl: employee.coverUrl ? employee.coverUrl : "",
      sourceType: employee.sourceType,
      content: employee.content ? employee.content : "",
      videoUrl: employee.videoUrl ? employee.videoUrl : "",
      imagesUrl: employee.imagesUrl ? employee.imagesUrl : [],
      tags: employee.tags ? employee.tags : [],
      isSeller: employee.isSeller ? employee.isSeller : false,
      isDeliverer: employee.isDeliverer ? employee.isDeliverer : false,
      isCounSellor: employee.isCounSellor ? employee.isCounSellor : false,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/employees`);
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }
}
